import React, { useContext, useState } from "react";
import { Button, Typography } from "@mui/material";
import RpMUIModal from "@/components/modals/RpMUIModal";
import { useNavigate } from "react-router-dom";
import { subscriptionService } from "@/features/subscriptions/services/subscriptionService";
import { GlobalContext } from "@/helpers/contexts/contexts";
import { logger } from "@/helpers/loggerHelper";
import { HTTP_STATUS } from "@/config/constants";
import { getDashboardPath } from "@/helpers/utils";

export default function ContactToWantToSpendMore() {
  const { loggedInUser } = useContext(GlobalContext);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sendEmail, setSendEmail] = useState(false);

  const contact = async () => {
    setLoading(true);
    try {
      const res: any = await subscriptionService.clickHerePackageEmail({
        email: loggedInUser.email,
      });
      if (res.status === HTTP_STATUS.OK) {
        setSendEmail(true);
        // setTimeout(() => {
        //   history.replace("/dashboard");
        // }, 5000);
      }
    } catch (err) {
      logger.error("Error in clickHerePackageEmail", { err });
    } finally {
      setLoading(false);
    }
  };

  const handleOnClose = () => {
    if (loading) return;
    setOpen(false);
  };

  const handleOnOK = () => {
    if (loading) return;
    navigate(getDashboardPath(), { replace: true });
  };

  const renderThankYou = () => {
    return (
      <div className="text-center my-4">
        <Typography color="text.primary" variant="h5" gutterBottom>
          Thank You
        </Typography>
        <Typography
          color="text.primary"
          variant="body1"
          className="font-weight-bold"
        >
          A Hyperlocologist will be in contact shortly.
        </Typography>

        <div className="mt-4 text-center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleOnOK}
            className="mx-auto"
            fullWidth
          >
            OK
          </Button>
        </div>
      </div>
    );
  };

  return (
    <>
      <Button
        color="primary"
        className="text-capitalize font-weight-bold"
        onClick={() => setOpen(true)}
      >
        Click here
      </Button>

      <RpMUIModal open={open} onClose={handleOnClose} maxWidth="xs" persists>
        {sendEmail ? (
          renderThankYou()
        ) : (
          <div>
            <Typography color="text.primary" variant="h6" gutterBottom>
              The plans are designed by your brand team to maximize your
              returns. The $300 monthly plan is highly recommended based on an
              analysis of past performance.
              <br />
              If you still need a different plan, hit send now and we'll get in
              touch.
            </Typography>

            {loading && (
              <Typography
                color="text.primary"
                variant="subtitle2"
                className="my-3"
              >
                Sending request..
              </Typography>
            )}

            <div className="mt-4 d-flex align-items-center justify-content-center">
              <Button
                variant="outlined"
                onClick={handleOnClose}
                className="mr-2"
                color="primary"
                fullWidth
              >
                Don't send
              </Button>
              <Button
                variant="contained"
                onClick={contact}
                color="primary"
                fullWidth
              >
                Send
              </Button>
            </div>
          </div>
        )}
      </RpMUIModal>
    </>
  );
}
